import React from 'react';
import { languageContent } from '../../@helpers';

const { component } = languageContent();

const Chat = (props) => {
  return (
    <div class="chat-alma" id="chatControl">
        <div id="Chat-with-Alma">
            {component.Chatbot.promptBtnLabel}
        </div>
    </div>
  )
}

export default Chat;
